import React, { memo } from 'react'
import './index.scss'

// props
interface IProps {
  status?: 'fill' | 'empty';
  size?: 'default' | 'small';
  onClick?: () => void;
}

const BagIcon: React.FC<IProps> = ({ status = 'fill', size = 'default', onClick }) => {
  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <span className={`bag-icon ${status}-status ${size}-size`} data-cypid='bagIcon' onClick={handleClick}></span>
  )
}

export default memo(BagIcon)
